module.exports = __webpack_public_path__ + "img/dimensions.88cdff9c.png";